module.exports = __webpack_public_path__ + "static/media/krystal.33c21724.png";